export default __webpack_public_path__ + "static/media/clickSound.16254fe2.mp3";